'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (digit) {
  var number = digit * 1;
  return '' + (number < 10 ? 0 : '') + number;
};